<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">PO summary reports</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form @submit.prevent="frmSearch">
            <v-container grid-list-xl class="ma-0 pa-0" fluid>
              <v-layout row wrap>
                <v-flex xs12 md3>
                  <v-select 
                  v-bind:items="getAllCompanies" 
                  v-model="selection.company" 
                  label="Company code" 
                  item-value="company_code" 
                  clearable 
                  :error-messages="errors.collect('company code')"
                  v-validate="'required'" 
                  data-vv-name="company code" 
                  required>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.company_code }} - {{ data.item.description }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.company_code }} - {{ data.item.description }}
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md3>
                  <v-select v-bind:items="getAllDivisions" v-model="selection.division" label="Division" item-value="initial" clearable>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.initial }} - {{ data.item.description }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.initial }} - {{ data.item.description }}
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md3>
                  <v-select v-bind:items="getAllPlants" v-model="selection.plant" label="Plant" item-value="plant" clearable>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.plant }} - {{ data.item.description }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.plant }} - {{ data.item.description }}
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md3>
                  <v-select v-bind:items="getAllDepartments" v-model="selection.department" label="Department" item-value="initial" clearable>
                    <template slot="selection" slot-scope="data">
                      {{ data.item.initial }} - {{ data.item.description }}
                    </template>
                    <template slot="item" slot-scope="data">
                      {{ data.item.initial }} - {{ data.item.description }}
                    </template>
                  </v-select>
                </v-flex>

                <v-flex xs12 md3>
                  <v-menu 
                  ref="menuFrom" 
                  lazy 
                  :close-on-content-click="false" 
                  v-model="menuFrom" 
                  transition="scale-transition" 
                  offset-y full-width
                  :nudge-right="40" 
                  min-width="290px" 
                  :return-value.sync="selection.from_date">
                    <v-text-field 
                    slot="activator" 
                    label="From date" 
                    v-model="selection.from_date" 
                    append-icon="event" 
                    readonly
                    :error-messages="errors.collect('from date')"
                    v-validate="'required'" 
                    data-vv-name="from date" 
                    required></v-text-field>
                    <v-date-picker 
                      ref="picker" 
                      v-model="selection.from_date" 
                      no-title 
                      scrollable
                      :max="selection.to_date">
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="menuFrom = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.menuFrom.save(selection.from_date)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 md3>
                  <v-menu 
                  ref="menuTo" 
                  lazy 
                  :close-on-content-click="false" 
                  v-model="menuTo" 
                  transition="scale-transition" 
                  offset-y 
                  full-width
                  :nudge-right="40" 
                  min-width="290px" 
                  :return-value.sync="selection.to_date">
                    <v-text-field 
                    slot="activator" 
                    label="To date" 
                    v-model="selection.to_date" 
                    append-icon="event" 
                    readonly
                    :error-messages="errors.collect('to date')"
                    v-validate="'required'" 
                    data-vv-name="to date" 
                    required></v-text-field>
                    <v-date-picker 
                      ref="picker" 
                      v-model="selection.to_date" 
                      no-title 
                      scrollable
                      :min="selection.from_date"> 
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="menuTo = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.menuTo.save(selection.to_date)">OK</v-btn>                      
                    </v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12 md2>
                  <v-btn  @click="frmSearch()" color="secondary">
                    <v-icon left dark>search</v-icon>
                    search
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-card-text>
          <v-data-table 
          v-bind:headers="headers" 
          v-bind:items="items" 
          v-bind:search="search" 
          v-model="selected" 
          item-key="id"  
          class="elevation-0"
          :loading="getLoading"
          :rows-per-page-items="[20]" 
          :pagination.sync="pagination"
          :total-items="totalItems">
            <template slot="headerCell" slot-scope="props">
              <span>
                {{ props.header.text }}
              </span>
            </template>
            <template slot="items" slot-scope="props">
                <td class="text-xs-left">{{ props.item.po_number}}</td>              
                <td class="text-xs-left">{{ props.item.total_value | currency}}</td>              
                <td class="text-xs-left">{{ props.item.created_date | formatDateTime}}</td>              
                <td class="text-xs-left">{{ props.item.updated_date | formatDateTime}}</td>              
                <td class="text-xs-left">{{ props.item.status}}</td>              
                <td class="text-xs-left">{{ props.item.approver}}</td>              
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'po-report',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      pagination: {},
      totalItems: 0,
      selection: {
        company: null,
        plant: null,
        division: null,
        department: null,
        from_date: null,
        to_date: null,
        page: null
      },
      headers: [
        {
          text: 'Document No.',
          align: 'left',
          value: 'document_no'
        },
        {
          text: 'Total Value',
          align: 'left',
          value: 'toval_value'
        },
        {
          text: 'Created Date',
          align: 'left',
          value: 'created_at'
        },
        {
          text: 'Updated Date',
          align: 'left',
          value: 'updated_at'
        },
        {
          text: 'Status',
          align: 'left',
          value: 'status'
        },
        {
          text: 'Approver',
          align: 'left',
          value: 'approver'
        }
      ],
      items: [],
      menuFrom: false,
      menuTo: false,
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      loader: null,
      loading3: false,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    }
  },
  computed: {
    ...mapGetters([
      'getLoading',
      'getResponse',
      'getAllCompanies',
      'getAllDivisions',
      'getAllDepartments',
      'getAllPlants',
      'getApprovalUsers',
      'getPoReport'
    ])
  },
  watch: {
    pagination: {
      handler () {
        if (this.selection.company) {
          this.selection.page = this.pagination.page
          this.searchPO(this.selection).then(() => {
            this.items = Object.assign([], this.getPoReport.items)
            this.totalItems = this.getPoReport.total
          })
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'fetchAllCompanies',
      'fetchAllDivisions',
      'fetchAllDepartments',
      'fetchAllPlants',
      'fetchApprovalUsers',
      'searchPO'
    ]),

    frmSearch: function () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.selection.page = this.pagination.page
          this.searchPO(this.selection).then(() => {
            this.items = Object.assign([], this.getPoReport).items
            this.totalItems = this.getPoReport.total
          })
        }
      })
    }
  },
  mounted: function () {
    this.fetchAllCompanies()
    this.fetchAllDivisions()
    this.fetchAllDepartments()
    this.fetchAllPlants()
    this.fetchApprovalUsers()
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/report/PoReport.vue